import { Component, ViewContainerRef } from '@angular/core';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { GalleryListModel } from '../../../models/gallery';
import { ContestSubmissionsSummaryModel } from '../../../models/contest';
import { ContestService } from '../../../services';
import { AppUtils } from '../../../helpers';

@Component({
    selector: 'gallery-search-result',
    templateUrl: './gallery.search.result.component.html'
})

export class GallerySearchResultComponent {
    @BlockUI('conatiner-designs') blockUI: NgBlockUI;

    selectedGallery: GalleryListModel = new GalleryListModel();
    submissions: Array<ContestSubmissionsSummaryModel> = new Array<ContestSubmissionsSummaryModel>();
    selectedSubmission: ContestSubmissionsSummaryModel = new ContestSubmissionsSummaryModel();
    dataLoadCompleted = false;
    modalReference: any;

    constructor(private vcr: ViewContainerRef,
        private toastr: ToastsManager,
        private modalService: NgbModal,
        private contestService: ContestService,
        private appUtils: AppUtils) {
        this.toastr.setRootViewContainerRef(this.vcr);
    }

    loadDesigns(selectedGallery: GalleryListModel) {
        this.dataLoadCompleted = false;
        this.submissions = new Array<ContestSubmissionsSummaryModel>();
        this.selectedGallery = selectedGallery;
        this.blockUI.start();
        this.contestService.getSubmissionsByGalleryId(this.selectedGallery.id)
            .subscribe(
                (data: any) => {
                    this.blockUI.stop();
                    this.dataLoadCompleted = true;
                    Object.assign(this.submissions, data);
                    this.submissions.map((item) => {
                        item.createdOn = this.appUtils.getFormattedDate(item.createdOn, null);
                    });
                },
                error => {
                    this.blockUI.stop();
                    this.appUtils.ProcessErrorResponse(this.toastr, error);
                });
    }

    open(content: any, selectedSubmission: ContestSubmissionsSummaryModel) {
        this.selectedSubmission = selectedSubmission;
        this.modalReference = this.modalService.open(content);
    }

    close() {
        this.modalReference.close();
    }

}



// WEBPACK FOOTER //
// ./src/components/gallery/search-result/gallery.search.result.component.ts